import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL !== undefined
  ? process.env.REACT_APP_API_URL
  : "http://localhost:8000";

export const getActiveAds = async (token, placement = "feed") => {
  try {
    const { data } = await axios.get(`${API_URL}/api/ads/active`, {
      params: { placement },
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Failed to load active ads:", error.message);
    return [];
  }
};

const recordedImpressions = new Set();

export const recordAdImpression = async (adId, token) => {
  if (!adId || !token || recordedImpressions.has(adId)) return;
  recordedImpressions.add(adId);
  try {
    await axios.post(
      `${API_URL}/api/ads/${adId}/impression`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
  } catch (error) {
    recordedImpressions.delete(adId);
    console.error("Failed to record ad impression:", error.message);
  }
};

export const recordAdClick = async (adId, token) => {
  try {
    await axios.post(
      `${API_URL}/api/ads/${adId}/click`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
  } catch (error) {
    console.error("Failed to record ad click:", error.message);
  }
};

export const getMyAds = async (token) => {
  const { data } = await axios.get(`${API_URL}/api/ads/mine`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return Array.isArray(data) ? data : [];
};

export const submitAd = async (formData, token) => {
  const { data } = await axios.post(`${API_URL}/api/ads/submit`, formData, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const hideAd = async (adId, token) => {
  const { data } = await axios.post(
    `${API_URL}/api/ads/${adId}/not-interested`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
};

function uniqueAdsById(ads) {
  const unique = [];
  const seen = new Set();
  (ads || []).forEach((ad) => {
    const id = ad && ad._id != null ? String(ad._id) : "";
    if (!id || seen.has(id)) return;
    seen.add(id);
    unique.push(ad);
  });
  return unique;
}

export function interleaveFeedAds(posts, ads, interval = 4) {
  const validPosts = (posts || []).filter((post) => post && post.user);
  const uniqueAds = uniqueAdsById(ads);

  if (!uniqueAds.length) {
    return validPosts.map((post) => ({ kind: "post", data: post }));
  }

  if (!validPosts.length) {
    return uniqueAds.map((ad) => ({ kind: "ad", data: ad }));
  }

  const items = [];
  let adIndex = 0;

  validPosts.forEach((post, index) => {
    items.push({ kind: "post", data: post });
    if ((index + 1) % interval === 0 && adIndex < uniqueAds.length) {
      items.push({ kind: "ad", data: uniqueAds[adIndex] });
      adIndex += 1;
    }
  });

  if (adIndex === 0) {
    items.push({ kind: "ad", data: uniqueAds[0] });
  }

  return items;
}
